/** function which filter enum values, to values which are true with given binary number
 * @function
 * @param {array} flags - array of all enum values(1,2,4,8,16,...)
 * @param {binaryNum} number - binary integer, which represents the array of selected flags
 * @returns {array}
 */
export const binaryToFlags = (flags, binaryNum) => flags.filter((f) => f & binaryNum);
